import React, {useState} from 'react'
import _ from '/home/ps/root'
import Logo from './logo'
import Side from './side'
import Footer from '../footer'
import View from '../../view'
import { Ref } from '../../../global'
export const ID = 'slide'
Ref[ID] = {}
// const _slide_ = Ref[ID]
const V = [
  [Side,  'l', 'sale', 'notice'],
  [Side, 't', 'menu', 'purchase'],
  [Logo, Logo.ID],
  [Footer, Footer.ID],
]
export default class Slide extends View {
  static ID = ID
  // static initialState = id => ({
  //   size: 'small',
  //   state: 'hide'
  // })
  constructor (p, c) {
    super(p, c)
    console.log({p,c})
    this.state = V.reduce((acc, comp) => {
      const [c, id] = comp
      // acc[id] = Slide.initialState(id)
      acc[id] = {
        size: 'small',
        state: 'hide'
      }
      return acc
    }, { key: `${ ID }` })
    // setTimeout(() => {
      this.props.setMaster({ slide: this.slide })
    // }, 1111)
  }
  componentDidMount = () => {
    // _Slide_[slide.key] = this.slide
    Ref[ID] = this
    // _slide_ = this
    setTimeout(() => {
      // this.props.setMaster({slide: this.slide})
    }, 1111)
  }
  prop = id => {
    const s = this.state[id]
    return {
      id: id,
      className: `${id} ${s.state} ${s.size}`,
    }
  }
  slide = (id, need) => {
    const s = this.state
    const state = s[id].state
    const nstate = need || (state=='show' ? 'hide' : 'show')
    const size = s[id].size
    const nsize = size == 'small' ? 'large' : 'small'
    let anyVisible = false
    const ns = {...s, [id]: {state: nstate, size}}
    V.reduce((acc, component) => {
      const [Curr, _id] = component
      const _state = ns[_id].state
      if (id=='logo') {
        ns[_id].state = ns.logo.state
        return acc
      } else if (_id!='logo' && ns[_id].state=='show')  anyVisible = true;
      return acc
    }, {})
    if (id!='logo') {
      if (!anyVisible) ns.logo.state = 'hide'
      if (ns[id].state=='show') ns.logo.state = 'show'
    }
    this.setState(ns, console.log(`Slide.state`, {id, state: this.state, ns}))
  }

  render = () => {
    const p = {...this.props, ...this.state, slide: this.slide, prop: this.prop}
    return (
      <div className={ID} onClick={e=>{
        e.preventDefault()
        e.stopPropagation()
      }}>
      {
        V.reduce((acc, i) => {
          const [Component, id, v1, v2] = i
          acc.push(<Component {...p} key={id}  ID={id} OnlineV={v1} V={v2}/>)
          return acc
        }, [])
      }
      </div>
    )
  }
}
